import { useContext } from 'react';
import { AppContext } from './GlobalContextProvide';

const ContextHelper = () => {
  const { currentUser, setCurrentUser, storeDataInLocalStorage, getDataFromLocalStorage } = useContext(AppContext);

  return {
    currentUser,
    setCurrentUser,
    storeDataInLocalStorage,
    getDataFromLocalStorage,
  };
};

export default ContextHelper;
